import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import GenericButton from './GenericButton';
import GenericFileUpload from './GenericFileUpload';

import * as definitionActions from '../../actions/definitionActions';

class ImportGeographyAndRespondent extends Component {
  constructor(props) {
    super(props);

    let definitionList = [];

    if (props.definitionList.data) {
      definitionList = props.definitionList.data;
    }
    this.state = {
      uploadFileName: '',
      newExpressions: [],
      definitionList,
      activetarget: 'existingDefinition',
      selectedDefinition: -1,
      newDefinitionFolder: '',
    };

    if (
      this.props.loginResponse &&
      this.props.activeAccountId &&
      this.props.moduleStudy
    ) {
      this.props.definitionActions.getDefinitionTreeLoad(
        this.props.loginResponse.data.token,
        this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.definitionList !== nextProps.definitionList &&
      nextProps.definitionList &&
      nextProps.definitionList.status === 'SUCCESS'
    ) {
      this.setState({ definitionList: [...nextProps.definitionList.data] });
    }
  }

  activeTarget = e => this.setState({ activetarget: e.target.value });

  handleImportCustomGeography = (data, fileName) => {
    const multipleGeoprahiesArray = data.trim().split('\n');
    const newDefinitionFolder = multipleGeoprahiesArray[0];
    const functionName = multipleGeoprahiesArray[1].trim();
    const catg = functionName.substring(2, functionName.length);
    const catgArray = this.props.geographySmartSearch.filter(geoData =>
      geoData.c.includes(catg),
    );
    const newExpressions = multipleGeoprahiesArray
      .slice(2, multipleGeoprahiesArray.length)
      .map(Geography => {
        const rawData = Geography.replace(/"/g, '')
          .trim()
          .split('\n');
        const dataPoint = catgArray.find(elm => elm.i === rawData[0]);
        if (dataPoint !== undefined) {
          const arrayData = rawData.reduce((accumulator, currentValue) => {
            accumulator.push(currentValue);
            return accumulator;
          }, []);
          return {
            id: 0,
            name: dataPoint.a,
            expression: `${functionName} ( ${arrayData.join(',')} )`,
          };
        }
      });
    const finalExp = newExpressions.filter(exp => exp !== undefined);
    this.setState({
      uploadFileName: fileName,
      newExpressions: finalExp,
      newDefinitionFolder,
    });
  };

  handleImportRespondents = (data, fileName) => {
    const multipleGeoprahiesArray = data.trim().split(';');
    const newExpressions = multipleGeoprahiesArray.map(Geography => {
      const rawData = Geography.replace(/"/g, '')
        .trim()
        .split('\n');
      const arrayData = rawData.reduce((accumulator, currentValue) => {
        if (!isNaN(parseInt(currentValue, 10))) {
          accumulator.push(parseInt(currentValue, 10));
        }
        return accumulator;
      }, []);
      return {
        id: 0,
        name: this.props.moduleStudy.st,
        respondentIds: arrayData,
      };
    });
    this.setState({ uploadFileName: fileName, newExpressions });
  };

  patchDefinition = () => {
    const patchDefinition = {
      token: this.props.loginResponse.data.token,
      ssid: this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      newExpressions: this.state.newExpressions,
      // refreshDefinitions: this.props.srcScreen === 'DefinitionScreen',
    };
    if (this.state.activetarget === 'existingDefinition') {
      patchDefinition.definitionId = this.state.selectedDefinition;
      this.props.definitionActions.patchTargetFolder(patchDefinition);
    } else {
      patchDefinition.folderName = this.state.newDefinitionFolder;
      patchDefinition.thisStudy = true;
      patchDefinition.shared = false;
      this.props.definitionActions.createNewDefinition(patchDefinition);
    }
  };

  renderDropdownData = () =>
    this.state.definitionList
      .filter(definition => definition.scope === 4 || definition.scope === 5)
      .map(({ folderName, definitionId }) => (
        <option value={definitionId} key={definitionId}>
          {folderName}
        </option>
      ));

  render() {
    return (
      <div>
        <form>
          <div className="row">
            <div className="large-12 columns">
              <div className="row">
                <div className="large-12 columns">
                  <label htmlFor="upload">
                    <div className="large-8 columns padding-left-0">
                      <input
                        type="text"
                        value={this.state.uploadFileName}
                        placeholder="File Name"
                      />
                    </div>
                    <div className="large-4 columns padding-0">
                      <GenericFileUpload
                        name="Browse"
                        btnStyle="button button-small"
                        handleUpload={
                          this.props.importType === 'Geography'
                            ? this.handleImportCustomGeography
                            : this.handleImportRespondents
                        }
                      />
                    </div>
                  </label>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="large-5 columns">
                    <input
                      type="radio"
                      name="radioDefinition"
                      value="existingDefinition"
                      checked={this.state.activetarget !== 'newDefinition'}
                      onChange={this.activeTarget}
                    />
                    <label htmlFor="existingDefinition">
                      Existing Definition
                    </label>
                  </div>
                  <div className="large-7 columns">
                    <select
                      value={this.state.selectedDefinition}
                      onChange={e =>
                        this.setState({
                          selectedDefinition: Number(e.target.value),
                        })
                      }
                      disabled={this.state.activetarget === 'newDefinition'}
                      style={{ height: '63px' }}
                    >
                      <option value={-1} key={-1}>
                        --select--
                      </option>
                      {this.renderDropdownData()}
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="large-5 columns">
                    <input
                      type="radio"
                      name="radioDefinition"
                      value="newDefinition"
                      checked={this.state.activetarget === 'newDefinition'}
                      onChange={this.activeTarget}
                    />
                    <label htmlFor="newDefinition">New Definition</label>
                  </div>
                  <div className="large-7 columns">
                    <input
                      disabled={this.state.activetarget !== 'newDefinition'}
                      type="text"
                      id="right-label"
                      placeholder=""
                      value={this.state.newDefinitionFolder}
                      style={{ marginBottom: '5px' }}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right button-group">
                <GenericButton
                  name="Ok"
                  btnStyle="button"
                  onBtnClick={() => {
                    this.patchDefinition();
                    this.props.handleHide();
                  }}
                />
                <GenericButton
                  name="Cancel"
                  btnStyle="button btn-cncl"
                  onBtnClick={() => this.props.handleHide()}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

ImportGeographyAndRespondent.propTypes = {
  handleHide: PropTypes.func,
  srcScreen: PropTypes.string,
  importType: PropTypes.string,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
    status: PropTypes.number,
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    st: PropTypes.string,
    ss: PropTypes.string,
  }),
  definitionList: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
    patchTargetFolder: PropTypes.func,
    createNewDefinition: PropTypes.func,
  }),
  geographySmartSearch: PropTypes.arrayOf(PropTypes.shape({})),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    definitionList: state.definition.definitionTree,
    geographySmartSearch: state.geographies.geographySmartSearch,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    definitionActions: bindActionCreators(definitionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImportGeographyAndRespondent);
